/**
 * Store des artefacts persistés (`artifact.created`) — cloisonné par conversation.
 *
 * Voir `convScopedStore.ts` pour la mécanique.
 */

import { createConvScopedStore } from '@ggvie-consulting/lib/convScopedStore'
import type { ArtifactResponse } from '@ggvie-consulting/types/artifacts'

export interface PersistedArtifactsState {
  conversation_id: string | null
  artifacts: ArtifactResponse[]
}

const store = createConvScopedStore<PersistedArtifactsState>((convId) => ({
  conversation_id: convId || null,
  artifacts: [],
}))

export const persistedArtifactsState = store.currentState
export const setCurrentConversation = store.setCurrentConversation
export const getPersistedStateForConv = store.getStateForConv
export const resetPersistedStateForConv = store.resetStateForConv
export const resetAllPersistedStates = store.resetAll

// Pas de `import.meta.hot.accept()` (cf. note dans gatheringArtifactStore.ts).
